import { useEffect, useState } from "react";
import { Upload, Form, message } from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";

const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};

const beforeUpload = (file) => {
  const isSupportedFormat =
    file.type === "image/jpeg" ||
    file.type === "image/png" ||
    file.type === "image/webp";

  if (!isSupportedFormat) {
    message.error("Hanya bisa mengupload file JPG, PNG, atau WEBP!");
    return false;
  }

  const isLt2MB = file.size / 1024 / 1024 < 2;
  if (!isLt2MB) {
    message.error("Ukuran file maksimal 2MB!");
    return false;
  }

  return true;
};

// eslint-disable-next-line react/prop-types
const ImageUploader = ({ form, name, label, imageFromAPI, ...restProps }) => {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    if (imageFromAPI) {
      setImageUrl(imageFromAPI);
    }
  }, [imageFromAPI]);

  const handleChange = (info) => {
    const file = info.file;
    
    if (!beforeUpload(file)) {
      return;
    }
    
    setLoading(true);
    
    getBase64(file, (url) => {
      setLoading(false);
      setImageUrl(url);
      
      // Store the actual file object in the form
      // eslint-disable-next-line react/prop-types
      form.setFieldValue(name, file);
    });
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  return (
    <Form.Item name={name} label={label} {...restProps}>
      <Upload
        name={name}
        listType="picture-card"
        showUploadList={false}
        beforeUpload={() => false} // Return false to stop auto upload
        onChange={handleChange}
        accept="image/jpeg,image/png,image/webp"
      >
        {imageUrl ? (
          <img 
            src={imageUrl} 
            alt="banner" 
            style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
            onError={() => {
              setImageUrl(null);
            }}
          />
        ) : (
          uploadButton
        )}
      </Upload>
    </Form.Item>
  );
};

export default ImageUploader;